
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ArgsTable, Canvas, Meta, Story } from '@storybook/addon-docs';
import floatDemo from './demo/float.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Utilities/Float" argTypes={{
      float: {
        options: ['inline-start', 'inline-end', 'none'],
        control: {
          type: 'select'
        }
      },
      breakpoint: {
        options: ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'],
        control: {
          type: 'inline-radio'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Float`}</h1>
    <p>{`Utilities for controlling the float of an element. Useful for responsively arranging imagery or other content adjacent to medium-to-long sections of text.`}</p>
    <h2>{`Flow-Relative Properties`}</h2>
    <p>{`These utilities use flow-relative values instead of specific directions `}<a parentName="p" {...{
        "href": "https://caniuse.com/mdn-css_properties_float_flow_relative_values"
      }}>{`in supported browsers`}</a>{` to simplify potential localization projects.`}</p>
    <p>{`The following table maps the traditional directional property for `}<inlineCode parentName="p">{`direction: ltr`}</inlineCode>{` and `}<inlineCode parentName="p">{`writing-mode: horizontal-tb`}</inlineCode>{` to its equivalent flow-relative property:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Directional Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Flow-relative Property`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`left`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`inline-start`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`right`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`inline-end`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Float Direction`}</h2>
    <p>{`The following float utilities are available:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`u-float-inline-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`u-float-inline-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`u-float-none`}</inlineCode></li>
    </ul>
    <p>{`Appending `}<inlineCode parentName="p">{`@{breakpoint}`}</inlineCode>{` to the end of these class names (example: `}<inlineCode parentName="p">{`u-float-inline-end@m`}</inlineCode>{`) will apply the float utility at the specified breakpoint and above.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Direction" args={{
        float: 'inline-end'
      }} mdxType="Story">
    {args => floatDemo(args)}
  </Story>
    </Canvas>
    <ArgsTable story="Direction" mdxType="ArgsTable" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const direction = (args => floatDemo(args));
direction.storyName = 'Direction';
direction.args = {
  float: 'inline-end'
};
direction.parameters = { storySource: { source: 'args => floatDemo(args)' } };

const componentMeta = { title: 'Utilities/Float', argTypes: {
  float: {
    options: ['inline-start', 'inline-end', 'none'],
    control: {
      type: 'select'
    }
  },
  breakpoint: {
    options: ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'],
    control: {
      type: 'inline-radio'
    }
  }
}, includeStories: ["direction"],  };

const mdxStoryNameToKey = {"Direction":"direction"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;